import { mediaItems } from '@/mocks/home';

export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-4xl font-heading text-foreground-950 mb-3">精选视频</h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-2xl mx-auto">
            漫画解说与深度分析视频精选，让你的阅读体验更立体
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 max-w-5xl mx-auto">
          {mediaItems.map((item) => (
            <a
              key={item.id}
              href="#media"
              className="group bg-background-100 rounded-xl overflow-hidden border border-background-200 hover:border-primary-200 transition-all duration-300 cursor-pointer"
            >
              <div className="aspect-video overflow-hidden relative">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute inset-0 flex items-center justify-center">
                  <div className="w-14 h-14 flex items-center justify-center rounded-full bg-background-50/90 group-hover:bg-primary-500 transition-colors">
                    <i className="ri-play-fill text-2xl text-foreground-800 group-hover:text-background-50 transition-colors ml-0.5"></i>
                  </div>
                </div>
              </div>
              <div className="p-4">
                <h3 className="text-sm font-heading text-foreground-900 mb-2 group-hover:text-primary-500 transition-colors line-clamp-2">
                  {item.title}
                </h3>
                <div className="flex items-center justify-between text-xs text-foreground-400">
                  <span>{item.author}</span>
                  <span><i className="ri-eye-line mr-1"></i>{item.views}</span>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}